import { render, staticRenderFns } from "./vuecommq1ys.vue?vue&type=template&id=3c9efc70&scoped=true&"
import script from "./vuecommq1ys.vue?vue&type=script&lang=js&"
export * from "./vuecommq1ys.vue?vue&type=script&lang=js&"
import style0 from "./vuecommq1ys.vue?vue&type=style&index=0&id=3c9efc70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9efc70",
  null
  
)

export default component.exports